import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";

import { loggedOut, selectIsAdmin, selectUserId } from "@/store/authSlice";
import { useAppDispatch, useAppSelector } from "@/store";

// Nav lives on the bright Material Blue bar — light text, white hover.
const navItem =
  "px-3 py-2 rounded-md text-sm font-medium text-white/85 hover:text-white hover:bg-white/10 transition-colors";
const navItemActive = "bg-white/15 text-white hover:bg-white/20";

export function AppLayout() {
  const userId = useAppSelector(selectUserId);
  const isAdmin = useAppSelector(selectIsAdmin);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onLogout = () => {
    dispatch(loggedOut());
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen flex justify-center bg-wall">
      {/* Centered frame (mutalisk pattern): everything sits inside this dark
          column with the light "wall" color flanking it on either side. */}
      <div className="w-full max-w-[1200px] flex flex-col bg-app text-ink">
        <header className="bg-brand-bar">
          <div className="flex items-center justify-between px-6 py-3">
            <Link to="/" className="font-semibold text-xl tracking-[0.18em] text-white">
              QRAFT <span className="text-white/90">EMP</span>
            </Link>
            <nav className="flex items-center gap-1">
              <NavLink to="/products" className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""}`}>
                Portfolio
              </NavLink>
              {isAdmin && (
                <>
                  <NavLink to="/report" className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""}`}>
                    Report
                  </NavLink>
                  <NavLink to="/stats" className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""}`}>
                    Stats
                  </NavLink>
                  <NavLink to="/users" className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""}`}>
                    Users
                  </NavLink>
                  <NavLink to="/banner" className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""}`}>
                    Banner
                  </NavLink>
                </>
              )}
            </nav>
            <div className="flex items-center gap-3 text-sm">
              <span className="text-white/85">
                {userId}
                {isAdmin && (
                  <span className="ml-2 rounded bg-white/15 text-white text-xs font-medium px-1.5 py-0.5">
                    admin
                  </span>
                )}
              </span>
              <button
                onClick={onLogout}
                className="px-3 py-1.5 rounded-md border border-white/40 text-white/85 hover:text-white hover:border-white"
              >
                Logout
              </button>
            </div>
          </div>
        </header>
        <main className="flex-1 w-full px-6 py-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
